import { render, staticRenderFns } from "./StaffTempMoment.vue?vue&type=template&id=6c3170c2&scoped=true"
import script from "./StaffTempMoment.vue?vue&type=script&lang=js"
export * from "./StaffTempMoment.vue?vue&type=script&lang=js"
import style0 from "./StaffTempMoment.vue?vue&type=style&index=0&id=6c3170c2&prod&scoped=true&lang=css"
import style1 from "./StaffTempMoment.vue?vue&type=style&index=1&id=6c3170c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3170c2",
  null
  
)

export default component.exports